import { render, staticRenderFns } from "./cv-skeleton-text.vue?vue&type=template&id=671fa612&"
import script from "./cv-skeleton-text.vue?vue&type=script&lang=js&"
export * from "./cv-skeleton-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports